import React from 'react';
import ReactDOM from 'react-dom/client';
import { ToastContainer, toast } from 'react-toastify';

import Router from 'routes/router';
import i18n from 'hooks/i18n';
import { Contexts } from 'hooks/context';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Contexts>
      <Router />
      <ToastContainer
        pauseOnFocusLoss={false}
        position={toast.POSITION.TOP_RIGHT}
        autoClose={3000}
        pauseOnHover={false}
      />
    </Contexts>
  </React.StrictMode>,
);
